import React from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./CommonBreadcrumb.css";

export default function CommonBreadcrumb({ items }) {
  return (
    <div className="breadcrumb-wrapper">
      <Container>
        <Breadcrumb>
          {items.map((item, index) => (
            <Breadcrumb.Item
              key={index}
              linkAs={item.link ? Link : undefined}
              linkProps={item.link ? { to: item.link } : undefined}
              active={!item.link}
            >
              {item.label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </Container>
    </div>
  );
}
